

import { AnimatePresence } from "framer-motion"
import { motion } from "framer-motion"
import ErrorAlert from "../alerts/ErrorAlert"
import SuccessAlert from "../alerts/SuccessAlert"


export default function HeaderAlert({ error, success, clearError, clearSuccess }) {
    return (
        <AnimatePresence>
            {error && (
                <motion.div
                    initial={{ y: -5, opacity: 0 }}
                    animate={{ y: 0, opacity: 1, transition: { duration: 0.1, ease: "easeOut" } }}
                    exit={{ y: -5, opacity: 0, transition: { duration: 0.1, ease: "easeIn" } }}
                    className="position-fixed top-0 start-0 w-100"
                >
                    <ErrorAlert error={error} onDismiss={clearError} />
                </motion.div>
            )}

            {success && (
                <motion.div
                    initial={{ y: -5, opacity: 0 }}
                    animate={{ y: 0, opacity: 1, transition: { duration: 0.1, ease: "easeOut" } }}
                    exit={{ y: -5, opacity: 0, transition: { duration: 0.1, ease: "easeIn" } }}
                    className="position-fixed top-0 start-0 w-100"
                >
                    <SuccessAlert message={success} onDismiss={clearSuccess} />
                </motion.div>
            )}
        </AnimatePresence>
    )
}